import styled from 'styled-components';

export const Line = styled.div<{ $left: number }>`
  position: absolute;
  top: 0;
  left: ${({ $left }) => `${$left}px`};

  height: 100%;
  width: 1px;

  background: ${({ theme }) => theme.palette.error.main};
`;
